<gp-dropzone
  [multiple]="multiple"
  [maxFilesLimit]="maxFilesLimit"
  [maxSizeLimit]="maxSizeLimit"
  [maxFilenameLength]="maxFilenameLength"
  [accept]="accept"
  [disabled]="disabled"
  (selected)="onChange($event)"
></gp-dropzone>
